import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/votefriend/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/votefriend/labels')
  },
  getIndex () {
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/votefriend/index')
  },
  postSave (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/votefriend/update', saveParams)
  },
  getProfile () {
    if (isMock) return generator(mocker.profile())
    return instance().get(endpoint + '/votefriend/profile')
  }
}



// WEBPACK FOOTER //
// ./src/api/votefriend/index.js